<mat-toolbar>
  <atlas-menu></atlas-menu>
  <span class="middle-spacer"></span>
  <div class="logo-space">
    @if (isUATMode$ | async) {
      <span class="uat-text">
        User Acceptance Testing
      </span>
    }
  </div>

  <span class="insite-image"></span>
  <span
    ><mat-icon
    class="help-icon"
    matSuffix
    matTooltip="Help & Resources"
    i18n-matTooltip="@@helpAndResourcesTooltip"
    (click)="navigateToResources()"
    >help_outline</mat-icon
    ></span
    >
  </mat-toolbar>
